<script>
  import { createEventDispatcher } from 'svelte';
  
  const VARIANTS = [
    'primary', 'primary-outline',
    'secondary', 'secondary-outline',
    'tertiary', 'tertiary-outline',
    'link'
  ]
  const DEFAULT_VARIANT = 'primary'

  export let variant = DEFAULT_VARIANT;
  export let size = 'medium';

  $: if (VARIANTS.indexOf(variant) < 0) variant = DEFAULT_VARIANT

  const dispatch = createEventDispatcher();

  function onClick(event) {
    dispatch('click', event);
  }
</script>

<button
  type="button"
  class={`${size} ${variant}`}
  on:click={onClick}>
  <slot />
</button>

<style>

button {
  font-family: var(--font-family-primary);
  border: var(--border-width) solid var(--text-color);
  cursor: pointer;
  display: inline-block;
  min-width: 6em;
  
  /* Default variant */
  color: var(--text-color);
  background: var(--btn-bg);
  
  /* Default size */
  font-size: var(--font-size-md);
}

button:disabled {
  opacity: 40%;
  cursor: initial;
}

button:hover:not(:disabled):not(.link) {
  background: var(--btn-bg-active);
  transform: translateY(calc(var(--spacer-xs) * -1));
  box-shadow: var(--shadow) var(--btn-box-shadow-color);
}

button:active:not(:disabled):not(.link) {
  background: var(--btn-bg-active);
  box-shadow: var(--shadow-sm) var(--btn-box-shadow-color);
  transform: translateY(0);
}

/* Variants */
.primary {
  --btn-bg: var(--color-primary);
  --btn-bg-active: var(--color-primary);
  --btn-box-shadow-color: var(--color-primary-dark);
}

.secondary {
  --btn-bg: var(--color-secondary-light);
  --btn-bg-active: var(--color-secondary-light);
  --btn-box-shadow-color: var(--color-secondary);
}

.tertiary {
  --btn-bg: var(--color-tertiary-light);
  --btn-bg-active: var(--color-tertiary-light);
  --btn-box-shadow-color: var(--color-tertiary);
}

.primary-outline {
  --btn-bg: var(--color-white);
  --btn-bg-active: var(--color-primary);
  --btn-box-shadow-color: var(--color-primary-dark);
}

.secondary-outline {
  --btn-bg: var(--color-white);
  --btn-bg-active: var(--color-secondary-light);
  --btn-box-shadow-color: var(--color-secondary);
}

.tertiary-outline {
  --btn-bg: var(--color-white);
  --btn-bg-active: var(--color-tertiary-light);
  --btn-box-shadow-color: var(--color-tertiary);
}

.link {
  width: auto;
  min-width: 0;
  height: auto;
  border: none;
  padding: 0 !important;
  background: transparent;
  color: var(--link-color);
}

.link:hover {
  color: var(--link-color--hover);
}

/* Sizes */
.small {
  font-size: var(--font-size-sm);
  padding: var(--spacer-sm) var(--spacer-md);
}
.medium {
  font-size: var(--font-size-md);
  padding: var(--spacer-md) var(--spacer-lg);
}

.large {
  border-width: 2px;
  font-size: var(--font-size-lg);
  padding: var(--spacer-md) var(--spacer-xl);
}
</style>
